module.exports = __webpack_public_path__ + "media/images/camera-441afd15.svg";